module.exports = __webpack_public_path__ + "front/img/17.38ac95df.png";